import { useEffect } from "react"
import { createBrowserRouter, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, Outlet } from "react-router"
import * as Sentry from "@sentry/react"

import { rootRouter } from "../features/root/rootRouter"
import { notFoundRouter } from "../features/not-found/notFoundRouter"

import { AppError } from "./AppError"
import { App } from "./App"

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
})

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(
  createBrowserRouter,
)

export const router = sentryCreateBrowserRouter([
  {
    path: "",
    element: (
      <App />
    ),
    children: [
      {
        path: "",
        errorElement: (
          <AppError />
        ),
        element: (
          <Outlet />
        ),
        children: [
          ...rootRouter,
          ...notFoundRouter,
        ],
      },
    ],
  },
])
